import React from 'react';
import BaseSelect from './Select/BaseSelect';
import {map, intersectionBy, isArray} from 'lodash';

const getSelectedOptions = (options, values) =>
    intersectionBy(
        options,
        isArray(values)
            ? map(values, value => ({value}))
            : [{value: values}],
        'value'
    );

const FormSelect = ({value, options, ...props}) => (
    <BaseSelect
        value={getSelectedOptions(options, value)}
        options={options}
        // onChange={({ value }) => { // TODO later
        //     onChange({
        //         target: {
        //             type: 'text',
        //             id: props.id,
        //             name: props.name,
        //             value,
        //         },
        //     });
        // }}
        {...props}
    />
);

export default FormSelect;


// WEBPACK FOOTER //
// ./resources/assets/js/components/Form/FormSelect.js